import { TID } from "@/constants/testIds";

const PROMPTS = {
  setup_strategy: {
    label: "Setup / Strategy",
    hint: "What pattern, session, or plan drove today's trades?",
  },
  entry_exit_reasoning: {
    label: "Entry / Exit Reasoning",
    hint: "Why did you take these entries? Why did you exit when you did?",
  },
  emotions: {
    label: "Emotions",
    hint: "How did you feel? Fear, patience, FOMO, tilt? Be honest.",
  },
  mistakes: {
    label: "Mistakes",
    hint: "What would you undo if you could? What rule did you break?",
  },
  lessons: {
    label: "Lessons",
    hint: "What is one thing that made today worth remembering?",
  },
};

const TESTID_MAP = {
  setup_strategy: TID.fieldSetup,
  entry_exit_reasoning: TID.fieldReasoning,
  emotions: TID.fieldEmotions,
  mistakes: TID.fieldMistakes,
  lessons: TID.fieldLessons,
};

export function ReflectionSection({ entry, onFieldChange }) {
  return (
    <section className="space-y-5">
      <h3 className="font-head text-lg text-[#EBE5D9]">Reflection</h3>
      {Object.entries(PROMPTS).map(([key, { label, hint }]) => (
        <div key={key}>
          <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#CFA66A]">
            {label}
          </label>
          <p className="text-xs text-[#A39A8E] mb-2 mt-0.5 italic">{hint}</p>
          <textarea
            data-testid={TESTID_MAP[key]}
            rows={2}
            value={entry[key]}
            onChange={(e) => onFieldChange(key, e.target.value)}
            className="w-full bg-[#0F0E0C] border border-[#2E2A25] text-[#EBE5D9] px-3 py-2 focus:outline-none focus:border-[#CFA66A] transition-colors rounded-sm resize-none"
          />
        </div>
      ))}
    </section>
  );
}
